<svg
  viewBox="0 0 160 160"
  [style.--stroke-dashoffset]="440 - (440 * progress) / 100"
  [style.--strokeWidth]="strokeWidth"
  [style.--strokeWidthHalf]="strokeWidth / 2"
  [style.--size]="size + 'px'"
  [class.slow-transition]="slowTransition"
  appTransitionPreventor
>
  <circle cx="70" cy="70" r="70"></circle>
  <circle cx="70" cy="70" r="70" class="color-{{ color }}"></circle>
</svg>
